// ============================================================================
// CUSTOMER SERVICE
// ============================================================================

import { get, post, put, del } from '../client/axiosClient';
import { customerEndpoints } from '../endpoints/customer.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  EmptyResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  Customer,
  CreateCustomerRequest,
  UpdateCustomerRequest,
  CustomerFilterParams,
} from '../types/customer.types';

class CustomerService {
  async getAll(params?: CustomerFilterParams): Promise<PaginatedResponse<Customer>> {
    const endpoint = params
      ? buildEndpointWithQuery(customerEndpoints.list(), params)
      : customerEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<Customer>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<Customer>> {
    const response = await get<ApiResponse<Customer>>(customerEndpoints.getById(id));
    return response.data;
  }

  async create(data: CreateCustomerRequest): Promise<ApiResponse<Customer>> {
    const response = await post<ApiResponse<Customer>>(customerEndpoints.create(), data);
    return response.data;
  }

  async update(id: ID, data: UpdateCustomerRequest): Promise<ApiResponse<Customer>> {
    const response = await put<ApiResponse<Customer>>(customerEndpoints.update(id), data);
    return response.data;
  }

  async delete(id: ID): Promise<EmptyResponse> {
    const response = await del<EmptyResponse>(customerEndpoints.delete(id));
    return response.data;
  }
}

export const customerService = new CustomerService();
export default customerService;
